var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "doc-preview" },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c("CompassDialog", {
        attrs: {
          visible: _vm.showModal,
          size: "large",
          title: _vm.$t.__("common.labels.document") + " " + _vm.ident
        },
        on: {
          "update:visible": function($event) {
            _vm.showModal = $event
          },
          closed: function($event) {
            return _vm.$emit("close")
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__default" }, [
                  _c("div", [
                    _c("h3", { staticClass: "dialog__default--actions" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Actions")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "dialog__default--list" },
                      _vm._l(_vm.actions, function(action, index) {
                        return _c(
                          "li",
                          { key: index },
                          [
                            _c("CompassLink", {
                              staticClass: "dialog__default--link",
                              attrs: {
                                label: action.label,
                                link: action.href,
                                target: action.target
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    !_vm.loading
                      ? _c("embed", {
                          attrs: { src: _vm.url, type: "application/pdf" }
                        })
                      : _vm._e()
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }